import { call, put } from 'redux-saga/effects';
import { setIntegrationStatus } from '../../../state/integration/integrationSlice';
import { backendClient } from '../../../services/api/backend-client';
import bugsnagClient from '../../../services/bugsnag/bugsnag';

export function* disconnectCrmSaga(action) {
    const { crm } = action.payload;
    try {
        yield call(
            [backendClient, backendClient.delete],
            `integrations/${crm}/disconnect`
        );
        yield put(setIntegrationStatus({ crm, data: { connected: false, accountId: null, connectedAt: null } }));
    } catch (err) {
        bugsnagClient.notify(err);
        console.error(`Failed to disconnect ${crm}`, err?.response?.status, err?.message);
    }
}